"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RssModel = /*#__PURE__*/function () {
  function RssModel() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RssModel);

    if (!this.schema) {
      throw new Error('please implement this.schema');
    }

    Object.assign(this, this.schema().cast(payload, {
      abortEarly: false,
      stripUnknown: true
    }));
  }

  _createClass(RssModel, [{
    key: "validate",
    value: function validate() {
      if (!this.schema) {
        throw new Error('please implement this.schema');
      }

      return this.schema().validateSync(this, {
        abortEarly: false
      });
    }
  }]);

  return RssModel;
}();

module.exports = RssModel;